import * as Yup from 'yup';
import { getMatcherLocationsFromZip } from '../utils';
import memoize from 'lodash.memoize';

const emptyZipError = 'Please enter your zip code.';
const invalidZipError = 'Please enter a valid zip code.';
const maxCharZipError = 'Please enter five characters for your zip code.';
const getLocations = memoize(getMatcherLocationsFromZip);

const matcherZipSchema = Yup.object().shape({
  postal_code: Yup.string()
    .trim()
    .required(emptyZipError)
    .max(5, maxCharZipError)
    .matches(/^\d{5}$/, invalidZipError)
    .test('test-zip', invalidZipError, async (value: string) => {
      if (!value) {
        return true;
      }

      try {
        const data = await getLocations(value);

        return data.length > 0;
      } catch {
        console.error(`Error while fetching locations for zip code: ${value}`);
        return true;
      }
    })
});

export { matcherZipSchema };
